// src/router/index.js
import { createBrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Layout from "../Layouts/Layout.js";
import Home from "../pages/Home.js";
import About from "../pages/About.js";
import Articles from "../pages/Articles.js";
import Pages from "../pages/Pages.js";
import ArticleDetail from "../pages/ArticleDetail.js";
import PageDetail from "../pages/PageDetail.js";
import Search from "../pages/Search.js";
import Contact from "../pages/Contact.js";
import Formation, { FormationRedirect } from "../pages/Formation.js";
import NotFound from "../pages/NotFound.js";

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [location.pathname]);
  return null;
};

const Wrap = () => (
  <>
    <ScrollToTop />
    <Layout />
  </>
);

export const router = createBrowserRouter([
  {
    element: <Wrap />,
    children: [
      // Home
      { path: "/", element: <Home /> },
      { path: "/ar", element: <Home /> },
      { path: "/en", element: <Home /> },

      // About
      { path: "/about", element: <About /> },
      { path: "/:lang/about", element: <About /> },

      // Articles list (auto-filtered: category 6)
      { path: "/publications", element: <Articles /> },
      { path: "/:lang/publications", element: <Articles /> },

      // Pages list (auto-filtered: service 5)
      { path: "/ressources", element: <Pages /> },
      { path: "/:lang/ressources", element: <Pages /> },

      // Detail
      { path: "/article/:id/:slug?", element: <ArticleDetail /> },
      { path: "/:lang/article/:id/:slug?", element: <ArticleDetail /> },
      { path: "/page/:id/:slug?", element: <PageDetail /> },
      { path: "/:lang/page/:id/:slug?", element: <PageDetail /> },

      // Formation : deux listes séparées
      { path: "/encadrants", element: <Formation type="encadrant" /> },
      { path: "/:lang/encadrants", element: <Formation type="encadrant" /> },
      { path: "/diplomes", element: <Formation type="participant" /> },
      { path: "/:lang/diplomes", element: <Formation type="participant" /> },

      // Ancienne adresse
      { path: "/formation", element: <FormationRedirect /> },
      { path: "/:lang/formation", element: <FormationRedirect /> },

      // Search
      { path: "/search", element: <Search /> },
      { path: "/:lang/search", element: <Search /> },

      // Contact
      { path: "/contact", element: <Contact /> },
      { path: "/:lang/contact", element: <Contact /> },

      // 404
      { path: "*", element: <NotFound /> },
    ],
  },
]);
